import { Link, useLocation } from 'react-router-dom';

interface Props {
  open: boolean,
  handleLogoutModalOpen: () => void
}

// const myImageRelease = false;

const AccountSideBar = ({ open, handleLogoutModalOpen }: Props) => {
  const location = useLocation();
  const isActive = (path: string) => (location.pathname === path ? 'active' : '');

  return (
    <nav
      id="sidebar"
      className="sidebar js-sidebar"
      style={{
        marginLeft: open ? '0px' : '-260px',
      }}
    >
      <div
        className="sidebar-content js-simplebar"
        style={{
          backgroundColor: 'rgb(29, 76, 135)',
        }}
      >
        <Link className="sidebar-brand text-center" to="/" style={{ height: '65px', background: '#fff' }}>
          <img src="/img/logo.png" alt="BUILD-SELF" className="img-fluid" width="200" />
        </Link>
        <ul className="sidebar-nav" style={{ overflowY: 'auto' }}>
          <li className="sidebar-item pt-3">
            <Link className="account-sidebar-link" to="/">
              <i className="fa-solid fa-arrow-left fa-fw" />
              {' '}
              <span className="align-middle">Back to main menu</span>
            </Link>
          </li>

          <li className="sidebar-header py-0">
            <hr />
          </li>

          <li className="sidebar-header py-0">
            Account settings
          </li>
          <li className={`sidebar-item ${isActive('/my-account')}`}>
            <Link className="account-sidebar-link" to="/my-account">
              <i className="fa-solid fa-user-pen fa-fw" />
              {' '}
              <span className="align-middle">Profile changes</span>
            </Link>
          </li>
          <li className={`sidebar-item ${isActive('/my-account/change-password')}`}>
            <Link className="account-sidebar-link" to="my-account/change-password">
              <i className="fa-solid fa-lock fa-fw" />
              {' '}
              <span className="align-middle">Change password</span>
            </Link>
          </li>
          <li className={`sidebar-item ${isActive('/my-account/plans')}`}>
            <Link to="/my-account/plans" className="account-sidebar-link">
              <i className="fa-solid fa-file-circle-check fa-fw" />
              {' '}
              <span className="align-middle">Plan information</span>
            </Link>
          </li>
          <li className={`sidebar-item ${isActive('/my-account/payment-methods')}`}>
            <Link className="account-sidebar-link" to="/my-account/payment-methods">
              <i className="fa-solid fa-credit-card fa-fw" />
              {' '}
              <span className="align-middle">Payment method</span>
            </Link>
          </li>

          <li className="sidebar-header py-0">
            <hr />
          </li>

          <li className="sidebar-item" onClick={handleLogoutModalOpen}>
            <a href="#" className="account-sidebar-link">
              <i className="fa-solid fa-door-open fa-fw" />
              {' '}
              <span className="align-middle">Logout</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default AccountSideBar;
